import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { I18NextService } from 'angular-i18next';
import { MessageService } from 'primeng/api';
import { Observable, Subscriber } from 'rxjs';
import { requiredImageDimensions } from '../../integration-apps.types';

@Component({
  selector: 'app-integration-app-information-form',
  templateUrl: './integration-app-information-form.component.html',
  standalone: false
})
export class IntegrationAppInformationFormComponent {

  @Input({ required: true }) formGroup!: FormGroup;

  public selectedProtocol: string = 'https://';
  public fileName: string = '';

  constructor(
    public i18next: I18NextService,
    private messageService: MessageService
  ) {}

  onLogoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    this.fileName = file.name;

    this.processLogo(file).subscribe({
      next: (dataUrl) => {
        this.formGroup.get('iconUrl')?.setValue(dataUrl);
      },
      error: (error) => {
        
        const message = error === 'invalid-dimensions'
          ? this.i18next.t('integration-app-information-form_invalid_logo_dimensions',
            { width: requiredImageDimensions.width,
              height: requiredImageDimensions.height
            }) as string
          : this.i18next.t('integration-app-information-form_load_logo_failed') as string;

        this.messageService.add({
          severity: 'error',
          summary: message,
        });
      },
    });

    input.value = '';
  }

  private processLogo(file: File): Observable<string> {
    return new Observable((observer: Subscriber<string>) => {
      const image = new Image();
      const imageUrl = URL.createObjectURL(file);

      image.onerror = () => {
        URL.revokeObjectURL(imageUrl);
        observer.error('load-failed');
      };

      image.onload = () => {
        URL.revokeObjectURL(imageUrl);

        if (image.naturalWidth !== requiredImageDimensions.width || image.naturalHeight !== requiredImageDimensions.height) {
          observer.error('invalid-dimensions');
          return;
        }

        const canvas = document.createElement('canvas');
        canvas.width = requiredImageDimensions.width;
        canvas.height = requiredImageDimensions.height;

        const context = canvas.getContext('2d');
        if (!context) {
          observer.error('load-failed');
          return;
        }

        context.drawImage(image, 0, 0);
        observer.next(canvas.toDataURL('image/png'));
        observer.complete();
      };

      image.src = imageUrl;
    });
  }

}
